import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";
import { ShouldDisplayMessageCTADataFn } from "../../instantAnswerDataFunctions/shouldDisplayMessageCTADataFn";
import { UpdateTaxInformationCTA } from "./ctas";
export var TaxInformationIA = function TaxInformationIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    },
    additionalRequiredData: [ShippingContextDataFn, ShouldDisplayMessageCTADataFn]
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UPDATE_TAX_INFORMATION_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [UPDATE_TAX_INFORMATION_LIST1(strictLocalize), UPDATE_TAX_INFORMATION_LIST2(strictLocalize), UPDATE_TAX_INFORMATION_LIST3(strictLocalize)];
    }
  };
};
var UPDATE_TAX_INFORMATION_TITLE = function UPDATE_TAX_INFORMATION_TITLE(strictLocalize) {
  return strictLocalize({
    id: "l1ZLgf",
    defaultMessage: [{
      "type": 0,
      "value": "How to update your tax information"
    }]
  });
};
var UPDATE_TAX_INFORMATION_LIST1 = function UPDATE_TAX_INFORMATION_LIST1(strictLocalize) {
  return strictLocalize({
    id: "8wpPfo",
    defaultMessage: [{
      "type": 0,
      "value": "1. Go to your Account settings."
    }]
  });
};
var UPDATE_TAX_INFORMATION_LIST2 = function UPDATE_TAX_INFORMATION_LIST2(strictLocalize) {
  return strictLocalize({
    id: "JewRyB",
    defaultMessage: [{
      "type": 0,
      "value": "2. Navigate to the Import & tax information section within \"My profile\" to change details like your 1099-k, VAT."
    }]
  });
};
var UPDATE_TAX_INFORMATION_LIST3 = function UPDATE_TAX_INFORMATION_LIST3(strictLocalize) {
  return strictLocalize({
    id: "RPCIUR",
    defaultMessage: [{
      "type": 0,
      "value": "3. Save any changes you make."
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return UpdateTaxInformationCTA(strictLocalize);
};